/* eslint-disable unicorn/prefer-string-slice */
export var isServer = typeof window === 'undefined';
export function getDiameter(radius) {
    var index = radius.search(/[a-z]/);
    return "" + 2 * Number(radius.substring(0, index)) + radius.substring(index);
}
